import { SourcingStats } from 'api-clients/monolith';

import { Progress } from '@/components/ui/progress';
import { Typography, TypographyVariant } from '@/components/ui/typography';
import { getProgress } from '@/utils/progress';

interface ApplicantStatsProps {
  stats: SourcingStats;
  typographyVariant?: TypographyVariant;
}

export function ApplicantStats({
  stats,
  typographyVariant = 'text',
}: ApplicantStatsProps) {
  const { expected, actual } = stats;
  const progress = getProgress(expected, actual);

  return (
    <>
      <Typography variant={typographyVariant}>
        {actual ?? '-'} / {expected ?? '-'}
      </Typography>
      <Progress value={progress} />
    </>
  );
}
